export enum AlertTypes {
    INFO = "info",
    ERROR = "error",
    WARN = "warning",
    SUCCESS = "success",
}
